import { useRouter } from 'next/router'
import en from '../public/lang/en.js'
import vi from '../public/lang/vi.js'

/**
 * Resolves a LanguageConfig object ({ en, vi }) to the given locale string.
 * Falls back to `fallback` if the config is missing or the locale key is empty.
 *
 * Use this anywhere you have a layout.config field typed as LanguageConfig.
 *
 * @param {Object|undefined} languageConfig  - e.g. { en: "OTP Verification", vi: "Xác thực OTP" }
 * @param {'en'|'vi'} locale                 - current locale from router.locale
 * @param {string} fallback                  - default string when config is absent
 * @returns {string}
 */
export const getLayoutText = (languageConfig, locale, fallback = '') => {
    if (!languageConfig) return fallback
    const key = locale === 'vi' ? 'vi' : 'en'
    return languageConfig[key] || fallback
}

const useTrans = () => {
    const { locale } = useRouter()
    const trans = locale === 'vi' ? vi : en
    return trans
}

export default useTrans
